const INITIAL_STATE = {
  openChatDrawer: false,
  openRoom: false,
  settingPopupVisible: false,
  chatUser: null,
  unreadCount: 0,
  currentPage: '/',
};

const setOpenChatDrawer = (state, action) => ({
  ...state,
  openChatDrawer: action.openChatDrawer,
  openRoom: action.openRoom,
});

const setCurrentPage = (state, action) => ({
  ...state,
  currentPage: action.page,
});

const setOpenRoom = (state, action) => ({
  ...state,
  openRoom: action.openRoom,
  openChatDrawer: action.openChatDrawer,
  chatUser: action.user,
});

const setSettingPopupVisible = (state, action) => ({
  ...state,
  settingPopupVisible: action.settingPopupVisible,
});

const setUnreadCount = (state, action) => ({
  ...state,
  unreadCount: action.unreadCount,
});

function appReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case 'SET_OPEN_DRAWER' : {
      return setOpenChatDrawer(state, action);
    }
    case 'SET_OPEN_ROOM' : {
      return setOpenRoom(state, action);
    }
    case 'SET_SETTING_POPUP_VISIBLE' : {
      return setSettingPopupVisible(state, action);
    }
    case 'SET_UNREAD_COUNT' : {
      return setUnreadCount(state, action);
    }
    case 'SET_CURRENT_PAGE' : {
      return setCurrentPage(state, action);
    }
    default : return state;
  }
}

export default appReducer;


// WEBPACK FOOTER //
// ./src/reducers/app.js